<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>Visa om uppehåll</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="">
        <v-row no-gutters>
          <v-col cols="4">
            <p class="overline">Ansökan skapad av</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.firstName">
              <router-link :to="'/people/' + selectedPerson.id">
                {{ selectedPerson.firstName || '' }}
                {{ selectedPerson.lastName || '' }}
              </router-link>
            </p>
          </v-col>
          <v-col cols="4">
            <p class="overline">MOBILNUMMER</p>
            <p class="mt-n3" v-if="selectedPerson.mobilephone">
              <a :href="`tel:${selectedPerson.mobilephone}`"> {{ selectedPerson.mobilephone | phoneNo }}</a>
            </p>
          </v-col>
          <v-col cols="4"
            ><p class="overline">E-POSTADRESS</p>
            <p class="mt-n3" v-if="selectedPerson && selectedPerson.email">
              <a :href="`mailto:${selectedPerson.email}`"> {{ selectedPerson.email }}</a>
            </p>
          </v-col>

          <v-col cols="12"
            ><p class="overline">Status</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="qtm && qtm.status">
                {{ qtm.status }}
              </p>
            </div>
          </v-col>
          <v-col cols="12"
            ><p class="overline">Startdatum (från och med)</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="qtm && qtm.fromDate">
                {{ qtm.fromDate | date }}
              </p>
            </div>
          </v-col>

          <v-col cols="12"
            ><p class="mt-3 overline">Slutdatum (till och med)</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="qtm && qtm.toDate">
                {{ qtm.toDate | date }}
              </p>
              <p class="mt-n3" v-else>
                Avbrott (obestämt slutdatum)
              </p>
            </div>
          </v-col>

          <v-col cols="12"
            ><p class="overline mt-3">Motivering</p>
            <div class="d-flex">
              <p class="mt-n3" v-if="qtm && qtm.reason">
                {{ qtm.reason }}
              </p>
            </div>
          </v-col>
          <v-col cols="6"></v-col>
        </v-row>

        <!-- Couraes -->
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col cols="6"
            ><p class="overline mt-3">Ansökan av</p>
            <p class="mt-n3" v-if="qtm && qtm.createdBy">
              {{ qtm.createdBy | fullName }}
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
          <v-col cols="6"
            ><p class="overline mt-3">Godkänd av</p>
            <p class="mt-n3" v-if="qtm && qtm.approvedBySecondary">
              {{ qtm.approvedBySecondary | fullName }}
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>Ej godkänd.</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end mt-2">
        <v-btn color="secondary" @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

// @group Education
// EducationModal component
export default {
  name: 'QualificationViewModal',

  props: {
    // Person object with a default value
    qtm: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters('person', ['selectedPerson'])
  }
}
</script>
